import React, { FC } from 'react';
import { Row } from './Row';
import { IDaySize, useViewModel } from '@utils';
import { CalendarViewModel } from '../../../../../views';
import { observer } from 'mobx-react-lite';

interface RowsProps {
  size: IDaySize;
}

export const Rows: FC<RowsProps> = observer(({ size }) => {
  const calendarViewModel = useViewModel(CalendarViewModel);
  
  const content = [];
  for (let i = 1; i <= calendarViewModel.monthRowsBetweenInterval; i++) {
    content.push(
      <Row
        key={i}
        rowIndex={i}
        size={size}
      />
    );
  }

  return <>{content.map(item => item)}</>;
});